<template>
    <BModal id="helpModal" title="Help" size="lg" v-model="showHelpModal" body-class="px-3" title-class="h1" ok-only ok-title="Close">
        <div class="px-3">
            <template v-if="contentType === 'topic'">
                <h4>Topics</h4>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end fw-bold">Announcements, Listing:</b-col>
                    <b-col sm="8" class="py-2">Reports that contain listings of funding opportunity announcements (program announcements, requests for applications, requests for proposals).</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end fw-bold">Applications, Number:</b-col>
                    <b-col sm="8" class="py-2">Data on the number of applications NIH receives.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Applications, Requested Costs:</b-col>
                    <b-col sm="8" class="py-2">Data on the direct or total costs requested in applications NIH receives.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Awards, Constant Dollars:</b-col>
                    <b-col sm="8" class="py-2">Report on NIH funding in constant dollars.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Awards, Listing:</b-col>
                    <b-col sm="8" class="py-2">Reports that contain listings of grant or contract awards.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Awards, Number:</b-col>
                    <b-col sm="8" class="py-2">Data on the number of grants and contracts NIH awards.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Awards, Requested Costs:</b-col>
                    <b-col sm="8" class="py-2">Data on the direct or total costs originally requested in applications that resulted in a grant award.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Awards, Total Costs:</b-col>
                    <b-col sm="8" class="py-2">Data on the total costs of NIH grant and contract awards.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Budget, Appropriation:</b-col>
                    <b-col sm="8" class="py-2">Information on NIH appropriations.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Career Outcomes:</b-col>
                    <b-col sm="8" class="py-2">Reports on the career outcomes of NIH-supported trainees, fellows, and investigators. Examples include research grants received by former NIH trainees, or subsequent NIH grant activity of K award recipients.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Investigators, Age:</b-col>
                    <b-col sm="8" class="py-2">Data on the age of NIH-supported investigators.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Investigators, Applying:</b-col>
                    <b-col sm="8" class="py-2">Data on the number of applicants for NIH grants.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Investigators, Funded:</b-col>
                    <b-col sm="8" class="py-2">Data on the number of investigators supported by NIH grants.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Investigators, Funding Rates:</b-col>
                    <b-col sm="8" class="py-2">The percentage of applicants who receive a grant award.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Obligations, Length:</b-col>
                    <b-col sm="8" class="py-2">Information on the length (number of years) of obligated NIH grants.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Obligations, Number:</b-col>
                    <b-col sm="8" class="py-2">Data on the number of NIH research grant and contract obligations.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Obligations, Total Costs:</b-col>
                    <b-col sm="8" class="py-2">Data on the total cost of NIH research grant and contract obligations.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Stipends:</b-col>
                    <b-col sm="8" class="py-2">Information on the annual stipend levels for individuals receiving support through institutional research training grants or individual fellowships.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Success Rates:</b-col>
                    <b-col sm="8" class="py-2">Reports on the percentage of reviewed RPG applications receiving funding, computed on a fiscal year basis.</b-col>
                </b-row>
                <b-row class="border border-bottom-0">
                    <b-col sm="4" class="border-end  fw-bold py-2">Trainees, FTTPs:</b-col>
                    <b-col sm="8" class="py-2">Information on the number of full-time training positions awarded through Kirschstein-NRSA training grants and fellowships.</b-col>
                </b-row>
                <b-row class="border">
                    <b-col sm="4" class="border-end  fw-bold py-2">Trainees, Number:</b-col>
                    <b-col sm="8" class="py-2">Data on the number of individuals (trainees and fellows) supported through Kirschstein-NRSA training grants and fellowships.</b-col>
                </b-row>
            </template>
            <template v-else-if="contentType === 'variable'">
                <h4>Variables</h4>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">FY:</b-col>
                        <b-col sm="8" class="py-2">The report provides information on the topic for each of several years (usually fiscal years, October 1 – September 31).</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">IC:</b-col>
                        <b-col sm="8" class="py-2">Information presented by institute and center.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Mechanism:</b-col>
                        <b-col sm="8" class="py-2">Topic is summarized by NIH budget mechanism (see information on mechanisms <a href="http://officeofbudget.od.nih.gov/spending_hist.html" target="_blank">here</a>).</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">SBIR/STTR:</b-col>
                        <b-col sm="8" class="py-2">The topic summarized separately for Small Business Innovation Research and Small Business Technology Transfer programs.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Activity:</b-col>
                        <b-col sm="8" class="py-2">Information is summarized by activity code. For more information, refer to the <a href="https://grants.nih.gov/grants/funding/ac_search_results.htm" target="_blank">list of extramural grant and cooperative agreement activity codes</a>.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Type (Non-)competing:</b-col>
                        <b-col sm="8" class="py-2">Information is presented for different grant award types (for example, type 1s, type 2s, type 5s) or summarized by competing and non-competing awards. For more information, refer to the <a href="https://grants.nih.gov/grants/funding/ac_search_results.htm" target="_blank">list of extramural grant and cooperative agreement activity codes</a>.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Version (Amendments):</b-col>
                        <b-col sm="8" class="py-2">Topic is summarized by the version of the grant applications submitted (e.g., the original, first amended version, or second amended version of an application).</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Phase:</b-col>
                        <b-col sm="8" class="py-2">Topic is presented by award "phase." Used primarily in reports on SBIR/STTR programs.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Project Period:</b-col>
                        <b-col sm="8" class="py-2">Data is presented by the length of the awarded project period.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Solicited:</b-col>
                        <b-col sm="8" class="py-2">Information is reported separately for solicited and unsolicited research grants.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Grant:</b-col>
                        <b-col sm="8" class="py-2">Information is provided at the level of the individual grant.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Career Level:</b-col>
                        <b-col sm="8" class="py-2">Information is provided for investigators, trainees, or fellows of various career levels. Examples include reports that compare first-time and established investigators, reports on pre- and postdoctoral trainees, and reports on mentored and other K awards.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Gender, Age, and Degree:</b-col>
                        <b-col sm="8" class="py-2">Information in report is summarized by gender/age/degree of investigator, trainee, or fellow.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">PI:</b-col>
                        <b-col sm="8" class="py-2">Information is presented at the level of the individual investigator.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">State, Congressional District:</b-col>
                        <b-col sm="8" class="py-2">Information is summarized for each state or Congressional district in the U.S.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Organization Type:</b-col>
                        <b-col sm="8" class="py-2">Information is summarized for different types of organizations (e.g., awards to institutions of higher education, independent hospitals, non-profits, etc.).</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Organization:</b-col>
                        <b-col sm="8" class="py-2">Information presented at the level of the individual organization.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Department:</b-col>
                        <b-col sm="8" class="py-2">Information is summarized by academic department (applies to medical schools only).</b-col>
                    </b-row>
                    <b-row class="border">
                        <b-col sm="4" class="border-end  fw-bold py-2">Requested Budget:</b-col>
                        <b-col sm="8" class="py-2">Information is summarized for several strata of budgets requested in grant applications.</b-col>
                    </b-row>
            </template>
            <template v-else>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Institute/Center:</b-col>
                        <b-col sm="8" class="py-2">Use this filter to find reports that contain information about a specific NIH institute or center (IC). The value "All Aggregated" denotes NIH-wide reports that provide information that is summarized across all ICs.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Portfolio:</b-col>
                        <b-col sm="8" class="py-2">Reports are categorized by the collection (portfolio) of things being reported on. There might be reports on extramural programs, intramural programs, appropriations received, strategic plans, publications and patents resulting from NIH-supported research, etc.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Mechanism:</b-col>
                        <b-col sm="8" class="py-2">The major budget mechanisms found in standard NIH budget mechanism tables (see information on mechanisms <a href="http://officeofbudget.od.nih.gov/spending_hist.html" target="_blank">here</a>).</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Activity Code:</b-col>
                        <b-col sm="8" class="py-2">Activities refer to the three-character codes used to designate different categories of grants and contracts. Use the activity code filter to find reports containing information on specific activities. For more information, refer to the <a href="https://grants.nih.gov/grants/funding/ac_search_results.htm" target="_blank">list of extramural grant and cooperative agreement activity codes</a>.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Topic:</b-col>
                        <b-col sm="8" class="py-2">Reports are categorized by the type of information or data they contain. Reports may provide information on, for example, numbers of applications, numbers of awards, success rates, or career outcomes of NIH-supported trainees and fellows. For more information, see the current list of topics and their descriptions here.</b-col>
                    </b-row>
                    <b-row class="border border-bottom-0">
                        <b-col sm="4" class="border-end  fw-bold py-2">Variable:</b-col>
                        <b-col sm="8" class="py-2">Many reports include tables and charts that summarize a portfolio. The type of data presented in each cell of a table is referred to as the "topic" and the rows and columns are the "variables" by which the information is summarized. For example, a table might provide the total number of grant awards by institute/center and fiscal year where each row of the table is a different institute/center and each column is a different fiscal year. In this case, the topic is "Awards, Number" and the variables in the report are "IC" and "FY."
                            <div class="help-sub-header mt-3 fw-bold">Table schematic:</div>
                            <div class="p-3">
                                <b-row class="border border-bottom-0">
                                    <b-col sm="4" class="border-end  fw-bold py-2"></b-col>
                                    <b-col sm="8" class="py-2">Variable 1 (e.g, FY)</b-col>
                                </b-row>
                                <b-row class="border">
                                    <b-col sm="4" class="border-end">Variable 2 (e.g. IC)</b-col>
                                    <b-col sm="8" class="py-2">Topic (numbers of awards, success rates, funding amounts, etc.)</b-col>
                                </b-row>
                                <b-row class="py-2">
                                    <div class="note">For more information, see the current list of variables and their descriptions here.</div>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="border">
                        <b-col sm="4" class="border-end  fw-bold py-2">Years:</b-col>
                        <b-col sm="8" class="py-2">Use this filter to find information for a particular (fiscal) year.</b-col>
                    </b-row>
                    <b-row>
                        <div class="note pt-3">Finally, please note that for a few reports the hyperlinks will take you to a report containing the information sought but not necessarily to the specific page, slide, or worksheet on which it can be found. A search within the document may be required. We anticipate that most future DIS reports will be designed to provide this capability.</div>
                    </b-row>
            </template>
        </div>
    </BModal>
</template>

<script>
import { mapGetters } from "vuex";
import bus from '@/shared/event-bus.js';

export default {
    name: 'helpModal',
    inject: ["mq"],
    computed: {
        ...mapGetters([
            'contentType'
        ])
    },
    data: function () {
        return {
            showHelpModal: false
        }
    },
    mounted () {
        bus.$on('help:show', () => {
            this.showHelpModal = true;
        });
    },
    methods: {
        closeModal () {
            this.showExportModal = false;
        },
    }
};
</script>

<style lang="scss">

    .note {
        font-size: 12px;
    }

    @media (min-width: 768px) {
        .modal-dialog {
            max-width: 675px;
        }
    }

</style>